var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganizationIconInactive = function SvgOrganizationIconInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeWidth: 1.5,
    d: "M12 8.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5ZM6 20.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5ZM18 20.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 9v3m0 0H7a1 1 0 0 0-1 1v2m6-3h5a1 1 0 0 1 1 1v2"
  })));
};
export { SvgOrganizationIconInactive as ReactComponent };
export default __webpack_public_path__ + "f0b9c658d3e6d8132f9757f263243378.svg";